import {useState} from "react";

const useLocalStorage = (key, isString) => {

    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? isString ? item : JSON.parse(item) : undefined;
        } catch (error) {
            // If error also return undefined
            return undefined;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = value => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore =
                value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, typeof valueToStore === "string" ? valueToStore : JSON.stringify(valueToStore));
        } catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };

    // Return function that remove stored value
    const removeValue = () => {
        // Save state with null
        setStoredValue(null);
        // Remove item of local storage
        window.localStorage.removeItem(key);
    };

    return [storedValue, setValue, removeValue];

};

export default useLocalStorage;